import Vue from 'vue';
import Toastr from '@/components/Toastr';
import moment from 'moment';

export default {
  data() {
    return {};
  },
  methods: {
    successNotify(msg) {
      var ComponentClass = Vue.extend(Toastr);
      var instance = new ComponentClass({
        propsData: { title: 'Success', message: msg, type: 'success' }
      });
      instance.$mount();
      var snackbarTag = document.getElementById('snackbar');
      snackbarTag.appendChild(instance.$el);
    },
    errorNotify(msg) {
      var ComponentClass = Vue.extend(Toastr);
      var instance = new ComponentClass({
        propsData: { title: 'Error', message: msg, type: 'error' }
      });
      instance.$mount();
      var snackbarTag = document.getElementById('snackbar');
      snackbarTag.appendChild(instance.$el);
    },
    warningNotify(msg) {
      var ComponentClass = Vue.extend(Toastr);
      var instance = new ComponentClass({
        propsData: { title: 'Warning', message: msg, type: 'warning' }
      });
      instance.$mount();
      var snackbarTag = document.getElementById('snackbar');
      snackbarTag.appendChild(instance.$el);
    },
    clearData(datas, specially) {
      if (!datas || {}.toString.call(datas) !== '[object Object]') {
        return;
      }
      if (!specially) {
        specially = {};
      }
      for (let attr in datas) {
        if (attr in specially) {
          datas[attr] = specially[attr];
        } else {
          datas[attr] = '';
        }
      }
      return datas;
    },
    navigatePush(routeName, params) {
      this.$router.push({ name: routeName, params: { ...params } }).catch(err => {});
    },
    navigateReplace(routeName, params) {
      this.$router.replace({ name: routeName, params: { ...params } }).catch(err => {});
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    },
    isUndefinedOrNullOrEmpty(v) {
      if (v) {
        if (typeof v === 'string') {
          if (v.length > 0) return false;
        }

        return false;
      } else {
        if (typeof v === 'number' && !isNaN(v)) return false;
      }

      return true;
    },
    setTimeZone(dateTime, currentFormat, format, timeZone = null) {
      if (dateTime !== undefined && dateTime !== null && dateTime !== '' && dateTime !== '0000-00-00 00:00:00') {
        if (format === undefined) format = 'YYYY-MM-DD HH:mm:ss';
        if (currentFormat === undefined) currentFormat = 'YYYY-MM-DD HH:mm:ss';
        if (timeZone == null) timeZone = '+0800';
        return moment(dateTime, currentFormat)
          .utc(true)
          .utcOffset(timeZone)
          .format(format);
      } else {
        return '-';
      }
    },
    convertTimestampToDate(timestamp, dateFormat) {
      if (!dateFormat) {
        dateFormat = 'HH:mm:ss';
      }
      return moment(timestamp).format(dateFormat);
    },
    downloadCanvas(element, fileName, fileType) {
      if (!fileType) {
        fileType = 'image/png';
      }
      if (!fileName) {
        fileName = 'File.png';
      }
      let image = element.toDataURL(fileType);
      let link = document.createElement('a');
      link.download = fileName;
      link.href = image;
      link.click();
    },
    convertToLocaleString(num = 0, decimal = 10) {
      // console.log('convertToLocaleString num', isNaN(Number(num)));
      if (isNaN(Number(num))) {
          return num;
      }
      return Number(num).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: decimal});
    }
  }
};

export function successNotify(msg) {
  var ComponentClass = Vue.extend(Toastr);
  var instance = new ComponentClass({
    propsData: { title: 'Success', message: msg, type: 'success' }
  });
  instance.$mount();
  var snackbarTag = document.getElementById('snackbar');
  snackbarTag.appendChild(instance.$el);
}

export function errorNotify(msg) {
  var ComponentClass = Vue.extend(Toastr);
  var instance = new ComponentClass({
    propsData: { title: 'Error', message: msg, type: 'error' }
  });
  instance.$mount();
  var snackbarTag = document.getElementById('snackbar');
  snackbarTag.appendChild(instance.$el);
}

export function warningNotify(msg) {
  var ComponentClass = Vue.extend(Toastr);
  var instance = new ComponentClass({
    propsData: { title: 'Warning', message: msg, type: 'warning' }
  });
  instance.$mount();
  var snackbarTag = document.getElementById('snackbar');
  snackbarTag.appendChild(instance.$el);
}

export function isUndefinedOrNullOrEmpty(v) {
  if (v) {
    if (typeof v === 'string') {
      if (v.length > 0) return false;
    }

    return false;
  } else {
    if (typeof v === 'number' && !isNaN(v)) return false;
  }

  return true;
}

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}
